module.exports = __webpack_public_path__ + "img/DHealth.f5ce83a4.svg";